import { useShallowSelector } from 'hooks';
import React, { useMemo } from 'react';
import { activeDrawerDataSelector } from 'store/drawers/selectors';
import { ApplicationState } from 'store/types';
import DrawerPicker from './DrawerPicker';

const DrawerContainer = () => {
  const { activeDrawers, drawerWidth } = useShallowSelector(({ drawers }: ApplicationState) => ({
    activeDrawers: activeDrawerDataSelector(drawers),
    drawerWidth: drawers.width,
  }));

  const drawersWithEmptyDrawer = useMemo(() => {
    const drawersToRender = activeDrawers.map((activeDrawer, i) => {
      const isFirstDrawer = i === 0;

      return (
        <DrawerPicker
          key={i.toString()}
          activeDrawerParams={activeDrawer}
          drawerWidth={drawerWidth}
          selectedItemsExist={false}
          isResizable={isFirstDrawer}
        />
      );
    });

    drawersToRender.push(
      <DrawerPicker
        key={activeDrawers.length.toString()}
        drawerWidth={drawerWidth}
        selectedItemsExist={false}
      />,
    );

    return drawersToRender;
  }, [activeDrawers, drawerWidth]);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{drawersWithEmptyDrawer}</>;
};

export default React.memo(DrawerContainer);
